import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('ShopPackBooster')
export class ShopPackBooster {

  @JsonProperty('booster_type', Number)
  boosterType: number = 0;

  @JsonProperty('booster_multiplier', Number)
  boosterMultiplier: number = 1;

  @JsonProperty('booster_duration', Number)
  boosterDuration: number = 0;
}
